// Greek Help Center: combines all section files into the two arrays
// the Documentation page consumes.
import { HELP_CATEGORIES } from './categories'
import { SECTION_ARTICLES as S1 } from './section-1'
import { SECTION_ARTICLES as S2 } from './section-2'
import { SECTION_ARTICLES as S3 } from './section-3'
import { SECTION_ARTICLES as S4 } from './section-4'
import { SECTION_ARTICLES as S5 } from './section-5'
import { SECTION_ARTICLES as S6 } from './section-6'
import { SECTION_ARTICLES as S7 } from './section-7'

export { HELP_CATEGORIES }
export const HELP_ARTICLES = [...S1, ...S2, ...S3, ...S4, ...S5, ...S6, ...S7]
